export default __webpack_public_path__ + "static/media/admin-01.fc4fdd0a.svg";